export const plans1 = [
	{
		title: 'Máster Completo',
		descrition: 'Flujo de producción completo.',
		price: '$999 USD',
		priceBefore: '$1.250 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_DK87KIECCF',
			internacional:
				'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTM5OSZpZD1MaWJlbCBIVUIgUGxhbiBGb3JnZSAtIEFjY2VzbyAxIGHxbw==',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Feedback en vivo.',
			},
			{
				title: 'Duración 8 meses.',
			},
			{
				title: 'Grabación de clases.',
			},
			{
				title: 'Acceso un año + 4 meses.',
			},
			{
				title: 'Certificado.',
			},
			{
				title: 'Material premium.',
			},
		],
		center: true,
		top: true,
		ball: false,
		promo: '30% DTO',
		type: 'presencial',
	},
];
